import React from "react";
import { useNavigate } from "react-router";
import Alert from "react-bootstrap/Alert";
import { Button, Modal } from "react-bootstrap";
import { getDisplayname } from "../../helpers/storage/user";

const PerformerProfilePictureMissing = ({ show, handleClose }) => {
  const navigate = useNavigate();

  const handleUploadPicture = () => {
    navigate("/settings");
    handleClose();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      className={`verify light`}
    >
      <Modal.Body className="mb-4">
        <h2 className="text-center mt-4 bold mb-4">Oops!</h2>
        <Alert variant="danger text-center">
          <Button
            variant="primary"
            className={`btn-sm red react red`}
            type="button"
          >
            <i className="fas fa-2x fa-exclamation"></i>
          </Button>
          <p>
          Hey {getDisplayname()}! You are required to upload a profile picture. Please click "Update Profile" to comply and receive full access to the platform.
          </p>
        </Alert>
      </Modal.Body>
      <div className="footer">
        <Button variant="default" onClick={handleClose}>
          Close
        </Button>
        <Button
            variant="default"
            type="submit"
            onClick={handleUploadPicture}
          >
            Update profile
          </Button>
      </div>
    </Modal>
  );
};

export default PerformerProfilePictureMissing;
